import { NumericFormat } from 'react-number-format';

export const Currency = ({ value, className }) => (
  <NumericFormat className={className} value={value.toFixed(2)} displayType="text" prefix="R " />
);
